import api from "../../services/api";

const useDashboard = () => {

    const find = async (params) => {
      try {
        console.log("[useDashboard] Fetching dashboard data with params:", params);
        const { data } = await api.request({
            url: `/dashboard`,
            method: 'GET',
            params
        });
        console.log("[useDashboard] Received data:", data);
        return data;
      } catch (error) {
        console.error("[useDashboard] Error fetching dashboard:", error);
        // Return empty structure instead of null to prevent UI crashes
        return [{
          counters: {
            avgSupportTime: 0,
            avgWaitTime: 0,
            supportHappening: 0,
            supportPending: 0,
            supportHappeningPeriod: 0,
            supportPendingPeriod: 0,
            supportClosed: 0,
            totalTickets: 0,
            uniqueTickets: 0,
            leads: 0,
            minResponseTime: 0,
            maxResponseTime: 0,
            messagesReceived: 0,
            messagesSent: 0,
            templatesSent: 0,
            liveOpen: 0,
            livePending: 0,
            liveActive: 0
          },
          attendants: [],
          messages: [],
          tickets: [],
          traking: []
        }];
      }
    }

    return {
        find
    }
}

export default useDashboard;
